import { ErrorCode, ErrorTemplate } from '~/enums/errorHandling/errorCode';
import { ObjectHelper } from "~/helpers/objectHelper";
import { StringHelper } from '~/helpers/stringHelper';
import { Hash } from "~/interfaces/hashInterfaces";
import store from "~/state/store";
import Model from '../model';

export default class ErrorHandler {
  constructor(private data: { code: ErrorCode, modelJson?: object }, private model: Model) {
  }

  updateModel(): void {
    if (this.data[this.model.provider.modelRoot]) {
      this.model.loadFromJson(this.data[this.model.provider.modelRoot])
    }
  }

  get message(): string {
    return ErrorHandler.message(this.data, {name: this.model['title']})
  }

  static message(data: { code: ErrorCode }, params: Hash = {}): string {
    if (!ObjectHelper.isHash(data)) {
      data = {code: ErrorCode.Unknown}
    }
    if (!ObjectHelper.isHash(params)) {
      params = {}
    }
    const template: string = ErrorTemplate[data.code] || ErrorTemplate[ErrorCode.Unknown]
    return StringHelper.interpolate(template, params)
  }

  static autosaveCatch(model, err) {
    model.registerAutosaveError(err);

    if (window.environment !== "production") {
      console.error(err);
    }
    
    let message = `Error: ${err.status} - ${err.statusText}`;
    //
    // for debugging
    // if (window.environment !== "production") {
    //   message += ` - ${err.responseText}`
    // }
    //
    store.commit('flashStore/set', {
      flash: {
        alert: message
      }
    });
  }

  static parseBetterErrors(errors) {
    let vals = [];
    Object.keys(errors).forEach(key => {
      let val = errors[key];
      if (typeof val === "string") {
        vals.push(`${key} > ${val}`)
      } else {
        vals.push(`${key} > ${ErrorHandler.parseBetterErrors(val)}`)
      }
    })
    return vals;
  }
}